import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout/layout"
import PageLayout from "../components/layout/page-layout"
import { FiArrowLeft } from "react-icons/fi"

import detailsStyles from "./competition-page.module.scss"

export const query = graphql`
  query($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`

const CompetitionDetails = props => {
  const { html } = props.data.markdownRemark
  const { title } = props.data.markdownRemark.frontmatter

  return (
    <Layout>
      <PageLayout title={title}>
        <div className={detailsStyles.wrapper}>
          <Link to="/competitions">
            <FiArrowLeft /> Back to competitions
          </Link>
          <div
            className={detailsStyles.content}
            dangerouslySetInnerHTML={{ __html: html }}
          ></div>
        </div>
      </PageLayout>
    </Layout>
  )
}

export default CompetitionDetails
